exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\n.c-quentity-format-recommend .custom-control-input:checked ~ .custom-control-label::before {\n    border-color: #048b84;\n    background-color: #048b84;\n}\n", ""]);
